/* eslint-disable camelcase */
  <template >
  <div v-role="'func'">
  <div>
  <div class="formPosition">
    <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>

    <v-data-table    :headers="headers"  :items="precos" :search="searchInDb"  sort-by="data_"   class="elevation-3" >
      <template v-slot:top>
        <v-toolbar flat color="white">

       <!--  <v-btn to="/painelclasses" > <v-icon large color="green darken-2">arrow_back</v-icon> </v-btn > -->

                 <v-divider class="mx-8" inset vertical></v-divider>
          <v-toolbar-title>Cadastro de Preços

            </v-toolbar-title>

          <v-divider class="mx-8" inset vertical></v-divider>
            <!--   <v-btn color="primary" dark class="mb-2" v-on="on">New Itemvv</v-btn>-->
            <div class="flex-grow-1"></div>
         <v-row>
        <v-col class="text-center" cols="4" ><v-btn x-large fab dark color="primary" @click="dialog=true">
              <v-icon dark>add</v-icon>
            </v-btn></v-col>
      </v-row>
          <!--  search  -->
<div   v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>

          <div class="flex-grow-1"></div>
          <v-btn  v-if="searchInDb"  @click="initialize(searchInDb)" text icon color="green">
              <v-icon>cached</v-icon>
            </v-btn>

          <v-dialog v-model="dialog" max-width="800px">

            <v-card>

              <template >

                  <v-toolbar color="grey lighten-2">

             <v-row>
                    <v-col sm="4" cols="12" md="4">

<v-btn text    @click="close"><v-icon large color="primary" >clear</v-icon></v-btn>

    </v-col>

     <v-col sm="7" cols="12" md="7">  <!--  form titlte section   {{ formTitle }}-->
   Cadastro de Preços
          <v-progress-circular
                v-if="progresso"
                indeterminate
                color="green"
        ></v-progress-circular>
     </v-col>

      <v-col sm="1"  cols="12" md="1">
     <v-btn   :disabled="!valid"           color="primary" text  @click="save"><v-icon large color="primary" >send</v-icon></v-btn>
   </v-col>

  </v-row>

                  </v-toolbar>

              </template>

 <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >

              <v-card-text>

                <v-container  >

<div   v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>

                   <v-row>
                    <v-col cols="12" md="6">
                      <v-combobox
                        v-model="cursoSelected"
                          :rules="ruleRequired"
                          item-value="pk_curso"
                          item-text="nome"
                            @change="loadTurmaComb"
                            @click="loadTurmaComb"

                          :items="cursos"
                          chips
                          label="Curso"
                      ></v-combobox>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-combobox
                        :rules="ruleRequired"
                        v-model="classesSelected"
                        :items="classes"
                        item-value="id"
                        @change="loadServico()"
                        item-text="descricao"
                        :disabled="cursoSelected === ''"
                        chips
                        label="Selecione a Classe"
                      ></v-combobox>
                    </v-col>
                     <v-col cols="12" md="6">
                      <v-combobox
                        v-model="serivoSelected"
                        :rules="ruleRequired"
                        item-value="pk_outros_servicos"
                        item-text="nome"
                        :items="servicosFiltered"
                        :disabled="classesSelected === ''"
                        chips
                        label="Selecione o serviço"
                      ></v-combobox>
                    </v-col>

   <v-col cols="12" md="6">
                       <v-text-field
                        :rules="ruleNumber"
                        v-model="preco"
                        label="Digite o valor"
                      ></v-text-field>
                    </v-col>

 </v-row>

                </v-container>
              </v-card-text>

</v-form>

            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.action="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
        <v-icon small @click="deleteItem(item)">delete</v-icon>
      </template>
      <template v-slot:no-data>
     <!--   <v-btn color="primary" @click="initialize">Reset</v-btn>  -->

     Clica em + para adicionar novo estudante
      </template>
    </v-data-table>

  </div>
</div>
</div>
</template>
My CRUD
<script>

import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
const ls = require('local-storage')
// const axios = require('../plugins/axios')
export default {
  directives: { mask },
  data: () => ({
    dropdowSexo: [
      { idSexo: 'M', descricao: 'Masculino' },
      { idSexo: 'F', descricao: 'Femenino' }
    ],

    progresso: false,
    descricao: 'Nº do Bi',
    valid: true,
    menu: false,
    preco: 0,
    cursoSelected: '',
    serivoSelected: '',
    menubi: false,
    ano_actual: ls.get('anolectivo'),
    habilitaBi: false,
    startDate: null,
    cursos: [],
    isLoading: false,
    turmasAll: [],
    mascara: '#########-AA-###',
    turmasFiltered: [],
    municipiosAll: [],
    cor: '',
    municipiosFiltered: [],
    provincias: [],
    precos: [],

    searchInDb: '',
    estudantes: [],
    servicos: [],
    servicosFiltered: [],
    dialog: false,
    idd: false, // simula autoinclemet

    y: 'top',
    text: 'mensagem nao setada.',
    valorFormatado: '',
    classesSelected: '',
    classes:
    [
      { id: 1, descricao: '10ª Classe' },
      { id: 2, descricao: '11ª Classe' },
      { id: 3, descricao: '12ª Classe' },
      { id: 4, descricao: '13ª Classe' }
    ],
    //  timeout: 4000,

    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleNumber: [
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /^[0-9]*$/
        return pattern.test(value) || 'Invalido.'
      }
    ],
    ruleBI: [

      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    headers: [
      {
        text: 'Curso',
        align: 'left',
        sortable: false,
        value: 'curso'
      },

      { text: 'Classe', value: 'classe' },
      { text: 'Serviço', value: 'servico' },
      { text: 'Preço', value: 'preco' },
      { text: 'data de cadastro', value: 'data_' },
      { text: 'autor', value: 'autor' },
      { text: 'Actions', value: 'action', sortable: false }
    ],

    msg: '',
    servicosPreco: [],
    editedIndex: -1,
    municSelectedForComb: null,
    proviSelectedForComb: null,
    editedItem: {

      pkPessoa: 0,
      bi: null,
      idPessoa: '',
      idMunicipio: null,
      idPerfil: null,
      nome: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      nomedopai: '',
      nomedamae: '',
      dataemissaobi: null,
      // eslint-disable-next-line no-dupe-keys
      bi: null,
      ResidenteEm: 1,
      instituicao: null,
      instituicaodescricao: '',
      curso: null,
      turma: null
    },
    defaultItem: {
      pkPessoa: 0,
      idPessoa: '',
      bi: '',
      idMunicipio: null,
      idPerfil: null,
      nome: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      nomedopai: '',
      nomedamae: '',
      dataemissaobi: '',
      // eslint-disable-next-line no-dupe-keys
      bi: '',
      ResidenteEm: '',
      instituicao: '',
      instituicaodescricao: '',
      curso: null,
      turma: null
    }
  }),

  computed: {

    /* preco:function()
    {
        return  (new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'AOA' }).format(preco))
    } */
    formTitle () {
      return this.editedIndex === -1 ? 'Inser novo Estudante' : 'Editar dados de Estudante'
    },
    idclasse () {
      return this.$store.state.idclasse
    },
    computeddatanascimento () {
      // eslint-disable-next-line no-undef
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format('dddd, MMMM Do YYYY') : ''
    },
    computedDateFormattedDatefns () {
      // eslint-disable-next-line no-undef
      return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
    },
    textMessage () {
      return this.$store.state.textMessage
    },

    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    },

    ListaActividades () {
      return ls.get('lista_actividades')
    }

  },

  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menubi (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.initializeCursos()
    this.initializeServicos()
    this.initializeServicosPreco()
  },

  methods: {

    async initializeServicos () {
      try {
        //   let  payload =""

        this.isLoading = true
        this.servicos = await axios
          .get('/ServicosFindAll')
          .then(res => res.data)
        console.log(this.servicos)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializeServicosPreco () {
      try {
        //   let  payload =""

        this.isLoading = true
        this.servicosPreco = await axios
          .get('/outrosServicosPrecoVerifica')
          .then(res => res.data)
        console.log(this.servicosPreco)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    loadServico () {
      let Servico_existente = this.servicosPreco.filter(s => s.fk_curso === this.cursoSelected.pk_curso && s.id_ano_academico === this.classesSelected.id)
      this.servicosFiltered = this.servicos
      if (Servico_existente.length) {
        for (let index = 0; index < Servico_existente.length; index++) {
          this.servicosFiltered = this.servicosFiltered.filter(s => s.pk_outros_servicos !== Servico_existente[index].fk_outros_servicos)
        }
      }
    },
    validate () {
      if (this.$refs.form.validate()) {

      } else {
        console.log('elso foraaa')
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    // END METHOD FOR VAL

    loadTurmaComb () { // setTimeout(() => { this.editedItem.turma=undefined }, 0)
      this.classesSelected = ''
    },

    chamaDialogo () {
      this.dialog = true
    },

    loadMunicipioComb (provincia) {
      this.$nextTick(() => { this.municSelectedForComb = undefined })
      // eslint-disable-next-line no-return-assign
      return this.municipiosFiltered = this.municipiosAll.filter(municipio => municipio.idProvincia === provincia.idProvincia)
    },

    async initializeCursos () {
      try {
        this.isLoading = true
        this.cursos = await axios
          .get('/cursoFindAll')
          .then(res => res.data)

        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    editItem (item) {
      this.editedIndex = this.estudantes.indexOf(item)
      this.editedItem = Object.assign({}, item)

      // let v=  Object.assign({},  this.municipios[5]);
      try {
        // prara trazer valores default na combo
        // procura na collecao ja carregada
        this.municSelectedForComb = this.municipiosAll.filter(mun => mun.idMunicipio === item.idMunicipio)
        // seta o valor encontrado
        this.municSelectedForComb = this.municSelectedForComb[0]

        this.proviSelectedForComb = this.provincias.filter(
          prov => prov.idProvincia === this.municSelectedForComb.idProvincia
        )

        this.proviSelectedForComb = this.proviSelectedForComb[0]
      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
      }

      this.dialog = true
    },

    deleteItem (item) {
      const index = this.estudantes.indexOf(item)
      confirm('Are you sure you want to delete this item?') &&
        this.delete(item.pkPessoa)
      // this.estudantes.splice(index, 1)
    },

    close () {
      this.dialog = false
      this.$refs.form.reset()
    },
    saveDate (date) {
      this.$refs.menu.save(date)
      this.editedItem.datanascimento = date

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.date = new Date(date).toISOString().substr(0, 10)
    },
    saveDatebi (datebi) {
      this.$refs.menubi.save(datebi)
      this.editedItem.dataemissaobi = datebi

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.datebi = new Date(date).toISOString().substr(0, 10)
    },
    async save () {
      if (this.$refs.form.validate()) {
        this.progresso = true
        this.ObterValorFormatado(this.preco)
        let params =
            {
              pk_outros_servicos_preco: 0,
              pk_curso: this.cursoSelected.pk_curso,
              idanoacademico: this.classesSelected.id,
              servico: this.serivoSelected.pk_outros_servicos,
              preco: this.valorFormatado.trim()
            }

        let params_tabela =
            {
              curso: this.cursoSelected.nome,
              classe: this.classesSelected.descricao,
              servico: this.serivoSelected.nome,
              preco: params.preco,
              data_: (new Date()),
              autor: ls.get('nomeUsuario')
            }

        try {
          let cor_mensagem = 'msgError'
          let msg = await axios
            .post('/precoServicoInsertOrUpdate', params)
            .then(res => res.data)
          this.progresso = false

          if (msg.length) {
            cor_mensagem = 'msgError'
            this.text = 'Ocorreu um erro ao tentar efectuar a operação'
          } else {
            cor_mensagem = 'msgSucess'
            this.text = 'Operação efectuada com sucesso'
            this.precos.unshift(params_tabela)
            this.dialog = false
          }
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': cor_mensagem, 'timeout': 5000 })
        } catch (error) {
          this.progresso = false
          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      }
    },

    ObterValorFormatado (valor) {
      let formated = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'AOA' }).format(valor)
      this.valorFormatado = formated.toString().replace('AOA', '')
    }

  }
}
</script>
<style scoped>

.bg {
 color:green;
 background: red
}

</style>
